import {useState} from 'react';
import {useForm} from 'react-hook-form';
import {User} from 'types';
import api from 'api';
import toast from 'react-hot-toast';
import useAuth from 'hooks/useAuth';
import {phoneFormat} from 'helpers/phoneFormat';
import {get} from 'lodash';

interface Option {
  label: string;
  value: string | number;
}

interface FormValue {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  username: string;
  password: string;
  password_confirmation: string;
  role: Option;
}

function useEmployeeForm() {
  const {currentUser, refetch} = useAuth();

  const [submitting, setSubmitting] = useState(false);

  const {
    handleSubmit,
    register,
    control,
    formState: {errors},
  } = useForm<FormValue>({
    defaultValues: {
      first_name: currentUser?.first_name,
      last_name: currentUser?.last_name,
      email: currentUser?.email,
      phone: phoneFormat(currentUser?.phone || ''),
      username: currentUser?.email,
    },
  });

  async function submit(data: FormValue) {
    setSubmitting(true);

    const user = {
      ...data,
      phone: data.phone.replace(/\D/g, ''),
      role: currentUser?.role,
    };

    try {
      await api.patch<User>(`/users/${currentUser?.id}/`, user);

      refetch(false);
      setSubmitting(false);
      toast.success('Account updated successfully');
    } catch (error) {
      const errors = get(error, 'response,data', {});
      const error_arr = Object.values(errors);
      toast.error(
        (get(error_arr, '[0]', '') as string) || 'Something went wrong'
      );
      setSubmitting(false);
    }
  }

  return {
    submitting,
    errors,
    control,
    register,
    handleSubmit: handleSubmit(submit),
  };
}

export default useEmployeeForm;
